module.exports = __webpack_public_path__ + "static/media/chicaHome.c72cdb98.jpg";